/************************************
 *
 * IMPORTANT: FOR THE FIREWAL, NAME THE ENDPOINTS WITH LOWER-CASE FIRST LETTERS
 *
 ************************************/

export const ENDPOINTS = {
  statusChangeAutomation: {
    main: 'statusChangeAutomation',
    all: 'statusChangeAutomation/all',
  },
  agent: {
    main: 'agentInstance',
    search: 'agentInstance/search',
    invocations: 'agentInstance/invocations',
  },
  agentType: {
    main: 'agentType',
    search: 'agentType/search',
  },
  account: {
    main: 'account',
    search: {
      main: 'account/search',
      export: 'account/search/export',
      external: 'account/search/external',
      v3: 'account/search/v3',
      exportV3: 'account/search/export/v3',
    },
    prospects: 'account/prospects',
    exists: 'account/exists',
    industries: 'account/industries',
    disable: 'account/disable',
    import: 'account/import',
    multiple: 'account/multiple',
    disableMultiple: 'account/disable/multiple',
    linkedin: {
      main: 'account/linkedin',
      multiple: 'account/linkedin/multiple',
    },
    sync: 'account/sync',
    push: 'account/push',
  },
  aircall: {
    authCallback: 'aircall/callback_oauth',
    verify: 'aircall/verify',
    connect: 'aircall/connect',
    disconnect: 'aircall/disconnect',
    contact: 'aircall/contact',
    powerDialer: 'aircall/PowerDialer',
  },
  scoreSettings: {
    main: 'scoreSettings',
  },
  scoreRefresh: {
    actives: 'scoreRefresh/actives',
  },
  score: {
    prospect: {
      main: 'score/prospect',
      refresh: 'score/prospect/refresh',
    },
    account: {
      main: 'score/account',
      refresh: 'score/account/refresh',
    },
  },
  analytics: {
    main: 'analytics',
    performance: {
      main: 'analytics/performance',
      team: 'analytics/performance/team',
      goals: 'analytics/performance/goals',
    },
    strategy: {
      main: 'analytics/strategy',
      detail: 'analytics/strategy/detail',
      overview: 'analytics/strategy/overview',
      dispersion: 'analytics/strategy/dispersion',
      conversion: 'analytics/strategy/conversion',
      steps: 'analytics/strategy/steps',
      replyTypes: 'analytics/strategy/replyTypes',
      cards: 'analytics/strategy/cards',
    },
    task: {
      main: 'analytics/task',
      v2: 'analytics/task/v2',
      rate: 'analytics/task/rate',
    },
    tags: 'analytics/tags',
    email: {
      main: 'analytics/email',
      heatmap: 'analytics/email/heatmap',
    },
    call: 'analytics/call',
    credits: 'analytics/credits',
    template: {
      main: 'analytics/template',
      email: 'analytics/template/email',
      linkedin: 'analytics/template/linkedin',
    },
    suggestion: 'analytics/suggestion',
    metrics: 'analytics/metrics',
    opportunity: {
      quanity: 'analytics/opportunity/quantity',
      values: 'analytics/opportunity/values',
      resume: 'analytics/opportunity/resume',
    },
    linkedin: 'analytics/linkedin',
    sequence: 'analytics/sequenceInstances',
    meeting: 'analytics/meeting',
    activity: {
      progression: 'analytics/activity/progression',
    },
    members: 'analytics/members',
    detail: {
      call: 'analytics/detail/call',
      email: 'analytics/detail/email',
      linkedin: 'analytics/detail/linkedin',
      todo: 'analytics/detail/todo',
      meeting: 'analytics/detail/meeting',
      prospect: 'analytics/detail/prospect',
      reply: 'analytics/detail/reply',
      sequenceContact: 'analytics/detail/sequenceContact',
      deal: 'analytics/detail/deal',
      activity: 'analytics/detail/activity',
    },
  },
  applyStatusMigration: {
    main: 'applyStatusMigration',
  },
  applySequenceChanges: {
    active: 'applySequenceChanges/active',
    allActive: 'applySequenceChanges/active/all',
  },
  assistant: {
    main: 'assistant',
    template: 'assistant/template',
    rewrite: 'assistant/rewrite',
    generateReply: 'assistant/generateReply',
    rewriteSequenceInstance: 'assistant/sequenceInstance/rewrite',
    rewriteSequenceInstanceInBulkProgress:
      'assistant/sequenceInstance/rewrite/bulk/InProgress',
    requeueSequenceInstancesRewrite:
      'assistant/sequenceInstance/rewrite/bulk/Requeue',
    revertRewrittenSequenceInstance: 'assistant/sequenceInstance/revertRewrite',
    strategy: {
      targetAudienceChallenges: 'assistant/strategy/targetAudienceChallenges',
      productBenefits: 'assistant/strategy/productBenefits',
      templates: {
        generate: 'assistant/strategy/templates/generate',
      },
    },
    aiVariable: {
      main: 'assistant/aiVariable',
      activeAnalytics: 'assistant/aiVariable/active/analytics',
    },
  },
  auth: {
    login: 'auth/login',
    logout: 'auth/logout',
    me: 'auth/me',
    refresh: 'auth/refresh',
    forbidden: 'auth/forbidden',
    password: 'auth/password',
    sendResetPasswordEmail: 'auth/sendResetPasswordEmail',
    terminateSessions: 'auth/sessions/terminate',
    resetPassword: {
      main: 'auth/resetPassword',
    },
    mfa: {
      verify: 'auth/mfa/verify',
      setup: 'auth/mfa/setup',
    },
    sso: {
      loginOkta: 'auth/sso/login/okta',
      loginMicrosoft: 'auth/sso/login/microsoft',
      loginGoogle: 'auth/sso/login/google',
    },
  },
  call: {
    external: 'call/external',
    recording: 'call/recording',
    transcript: {
      generate: 'call/transcript/generate',
    },
    twilio: {
      token: 'call/twilio/token',
      outbound: 'call/twilio/outbound',
      innbound: 'call/twilio/inbound',
      status: 'call/twilio/status',
      recording: {
        status: 'call/twilio/recording/status',
        start: 'call/twilio/recording/start',
      },
    },
  },
  conversation: {
    search: 'conversation/search',
    full: 'conversation/full',
    unread: 'conversation/unread',
    read: 'conversation/read',
  },
  crmPush: {
    main: 'crmPush',
    active: 'crmPush/active',
  },
  csrf: {
    main: 'csrf',
  },
  email: {
    main: 'email',
    saveSettings: 'email/save_settings',
    send: 'email/send',
    sendPreview: 'email/send/preview',
    schedule: 'email/schedule',
    scheduled: 'email/scheduled',
    sync: 'email/sync',
    thread: {
      main: 'email/thread',
      recent: 'email/thread/recent',
    },
    mailbox: {
      main: 'email/mailbox',
      alias: 'email/mailbox/alias',
      disconnect: 'email/mailbox/disconnect',
      default: 'email/mailbox/default',
    },
    // scheduleProspect: "email/schedule/prospect",
    searchEmails: 'email/searchEmails',
  },
  linkedin: {
    main: 'linkedin',
  },
  events: {
    main: 'event',
    call: 'event/call',
    callTranscript: 'event/call/transcript',
    email: 'event/email',
    generic: 'event/generic',
    linkedin: 'event/linkedin',
    conversation: {
      separate: 'event/linkedin/conversation/separate',
    },
    event: 'event',
    emailSync: 'event/email/sync',
    task: {
      main: 'event/task',
      email: 'event/task/email',
      linkedin: 'event/task/linkedin',
      call: 'event/task/call',
      last: 'event/task/last',
      invitation: 'event/task/last/invitation',
      conversation: 'event/task/last/conversation',
    },
    callReports: 'event/task/report/call',
    emailReports: 'event/task/report/email',
    linkedinReports: 'event/task/report/linkedin',
    check: {
      linkedin: 'event/check/linkedin',
      linkedinCelebrations: 'event/check/linkedin/celebrations',
      linkedinPublicIds: 'event/check/linkedin/publicIds',
    },
    activities: {
      search: 'event/activities/search',
    },
  },
  externalProperty: {
    main: 'externalProperty',
    option: 'externalProperty/option',
    usage: 'externalProperty/usage',
    crm: 'externalProperty/crm',
    status: {
      main: 'externalProperty/status',
      migrate: 'externalProperty/status/migrate',
    },
    ai: 'externalProperty/ai',
    sync: 'externalProperty/sync',
    settings: 'externalProperty/settings',
  },
  google: {
    authCallback: 'google/callback_oauth',
    calendarAuthCallback: 'google/calendar/callback_oauth',
    verify: 'google/verify',
    disconnect: 'google/disconnect',
    signature: 'google/signature',
  },
  calendar: {
    main: 'calendar',
    disconnect: 'calendar/disconnect',
    default: 'calendar/default',
    meeting: 'calendar/meeting',
  },
  customEmailProvider: {
    connect: 'customEmailProvider/connect',
    verify: 'customEmailProvider/verify',
    disconnect: 'customEmailProvider/disconnect',
    alias: 'customEmailProvider/alias',
    test: {
      smtp: 'customEmailProvider/test/smtp',
      imap: 'customEmailProvider/test/imap',
    },
  },
  hubspot: {
    authCallback: 'hubspot/callback_oauth',
    verify: 'hubspot/verify',
  },
  import: {
    main: 'import',
    actives: 'import/actives',
    stop: 'import/stop',
  },
  linkedinSettings: {
    main: 'linkedinSettings',
  },
  migration: {
    active: 'migration/active',
    main: 'migration',
  },
  notes: {
    main: 'note',
  },
  notifications: {
    main: 'notification',
    feed: 'notification/feed',
    patchAll: 'notification/all',
  },
  outlook: {
    authCallback: 'outlook/callback_oauth',
    verify: 'outlook/verify',
    disconnect: 'outlook/disconnect',
  },
  optout: {
    prospect: 'optout/prospect',
  },
  opportunity: {
    main: 'opportunity',
    multiple: 'opportunity/multiple',
    search: {
      main: 'opportunity/search',
      v2: 'opportunity/search/v2',
      list: 'opportunity/search/list',
      listV2: 'opportunity/search/list/v2',
      export: 'opportunity/search/list/export',
      exportListV2: 'opportunity/search/list/export/v2',
      account: 'opportunity/account/search',
    },
    disable: {
      main: 'opportunity/disable',
      multiple: 'opportunity/disable/multiple',
    },
    sync: 'opportunity/sync',
  },
  personalizedTemplate: {
    main: 'personalizedTemplate',
  },
  pipeline: {
    main: 'pipeline',
    sync: 'pipeline/sync',
    stage: 'pipeline/stage',
  },
  prospect: {
    main: 'prospect',
    multiple: 'prospect/multiple',
    optOut: 'prospect/optout',
    search: {
      main: 'prospect/search',
      export: 'prospect/search/export',
      external: 'prospect/search/external',
      strategy: 'prospect/search/strategy',
      v3: 'prospect/search/v3',
      exportV3: 'prospect/search/export/v3',
    },
    exists: 'prospect/exists',
    linkedin: {
      main: 'prospect/linkedin',
      multiple: 'prospect/linkedin/multiple',
    },
    disable: 'prospect/disable',
    disableMultiple: 'prospect/disable/multiple',
    invitationSent: 'prospect/invitationSent',
    newConnectionSet: 'prospect/newConnection/set',
    newLinkedinEventCheck: 'prospect/newLinkedinEvent/check',
    import: 'prospect/import',
    importLeads: 'prospect/import/leads',
    account: 'prospect/account',
    sync: 'prospect/sync',
    push: 'prospect/push',
  },
  salesforce: {
    saveToken: 'salesforce/save_token',
    authCallback: 'salesforce/callback_oauth',
    verify: 'salesforce/verify',
    image: 'services/images/photo', // salesforce Url
  },
  sync: {
    main: 'sync',
    actives: 'sync/actives',
    stop: 'sync/stop',
  },
  pipedrive: {
    authCallback: 'pipedrive/callback_oauth',
    verify: 'pipedrive/verify',
  },
  attio: {
    authCallback: 'attio/callback_oauth',
    verify: 'attio/verify',
  },
  zoho: {
    authCallback: 'zoho/callback_oauth',
    verify: 'zoho/verify',
  },
  dynamics: {
    environments: 'Dynamics/environments',
    authCallback: 'Dynamics/callback_oauth',
    verify: 'Dynamics/Verify',
    apps: 'Dynamics/Apps',
    settings: 'Dynamics/Settings',
  },
  hyperbound: {
    settings: 'Hyperbound/Settings',
  },
  slack: {
    authCallback: 'slack/callback_oauth',
    verify: 'slack/verify',
    disconnect: 'slack/disconnect',
    channels: 'slack/channels',
    channel: 'slack/channel',
    channelEvents: 'slack/channelEvents',
    channelOwnerFilter: 'slack/channelOwnerFilter',
    channelUpdates: 'slack/channelUpdates',
    user: {
      authCallback: 'slack/user/callback_oauth',
      verify: 'slack/user/verify',
      events: 'slack/user/events',
      ownerFilter: 'slack/user/ownerFilter',
      updates: 'slack/user/updates',
      disconnect: 'slack/user/disconnect',
    },
  },
  chartMogul: {
    main: 'chartMogul', // for invalidation
    verify: 'chartMogul/verify',
    connect: {
      manager: 'chartMogul/connect/manager',
      user: 'chartMogul/connect/user',
    },
  },
  strategySettings: {
    main: 'strategySettings',
  },
  strategy: {
    main: 'strategy',
    archive: 'strategy/archive',
    generate: 'strategy/generate',
    mailbox: {
      main: 'strategy/mailbox',
      check: 'strategy/mailbox/check',
    },
    resumableCount: 'strategy/resumableCount',
    usage: 'strategy/usage',
    prospect: 'strategy/prospect',
    prospectDelete: 'strategy/prospect/delete',
    prospectRepliedMultiple: 'strategy/prospect/replied/multiple',
    prospectDeleteMultiple: 'strategy/prospect/delete/multiple',
    prospectResumeMultiple: 'strategy/prospect/resume/multiple',
    prospectMultiple: 'strategy/prospect/multiple',
    step: {
      main: 'strategy/step',
      order: 'strategy/step/order',
    },
    conditional: {
      main: 'strategy/step/conditional',
      invitation: 'strategy/step/conditional/invitation',
    },
    search: 'strategy/search',
    apply: 'strategy/apply',
    duplicate: 'strategy/duplicate',
    stop: 'strategy/stop',
    details: 'strategy/details',
    stepTemplate: 'strategy/step/template',
    restart: 'strategy/prospect/restart',
    librarySearch: 'strategy/search/library',
    library: 'strategy/library',
    libraryDuplicate: 'strategy/duplicate/library',
  },
  scrape: {
    main: 'scrape',
    find: 'scrape/find',
    verifyScrape: 'scrape/find/verify',
    phone: 'scrape/find/phone',
    linkedin: 'scrape/find/linkedin',
    website: 'scrape/website',
    enrich: {
      company: 'scrape/enrich/company',
    },
    scrapeBulk: {
      prospect: 'scrape/find/bulk/prospect',
      company: 'scrape/find/bulk/company',
      activeAnalytics: 'scrape/find/bulk/active/analytics',
    },
  },
  status: {
    bob: 'api/status/bob',
  },
  task: {
    main: 'task',
    search: {
      main: 'task/search',
      linkedin: {
        next: 'task/search/linkedin/next',
      },
    },
    pending: 'task/pending',
    aggregate: 'task/aggregate',
    multiple: 'task/multiple',
    next: 'task/search/next',
    sequenceInstance: 'task/sequenceInstance',
    overdue: 'task/search/overdue',
    total: 'task/total',
    dailyQuantity: 'task/daily/quantity',
    multipleAutomatic: 'task/multiple/automatic',
    multipleInmail: 'task/multiple/Inmail',
    linkedin: {
      quantity: 'task/linkedin/quantity',
      stopAutomation: 'task/linkedin/stopAutomation',
      automatic: {
        last: 'task/linkedin/automatic/last',
        check: 'task/linkedin/automatic/check',
      },
    },
    dialerCampaign: 'task/dialerCampaign',
    automationErrors: 'task/withAutomationError',
    user: {
      analytics: 'task/user/analytics',
    },
  },
  suggestion: {
    main: 'suggestion',
    preferences: 'suggestion/preferences',
    search: 'suggestion/search',
  },
  template: {
    main: 'template',
    search: 'template/search',
    attachment: {
      main: 'template/attachment',
      file: 'template/attachment/file',
    },
    recording: { file: 'template/recording/file' },
    usage: 'template/usage',
    duplicate: 'template/duplicate',
    archive: 'template/archive',
  },
  templateVariables: {
    main: 'templateVariables',
    snippet: 'templateVariables/snippet',
  },
  file: {
    main: 'file',
  },
  subscription: {
    main: 'subscription',
    paymentCustomer: 'subscription/paymentCustomer',
    users: {
      main: 'subscription/users',
      manager: 'subscription/users/manager',
    },
    signup: {
      enable: {
        main: 'subscription/signup/enable',
        user: 'subscription/signup/enable/user',
      },
      isEnabled: 'subscription/signup/isEnabled',
    },
    manager: 'subscription/manager',
    otherSettings: 'subscription/otherSettings/manager',
    otherSettingsAdmin: 'subscription/otherSettings/admin',
    stripePortal: 'subscription/create-portal-session',
    stripeCheckout: 'subscription/create-checkout-session',
    products: {
      main: 'subscription/products',
      credits: 'subscription/products/credits',
      me: 'subscription/products/me',
    },
    complete: 'subscription/complete',
    startFreeTrial: 'subscription/startFreeTrial',
    site: {
      checkout: 'subscription/site/create-checkout-session',
    },
    credits: {
      checkout: 'subscription/credits/create-checkout-session',
    },
    multicustomer: {
      invite: {
        manager: 'subscription/multiCustomer/invite/manager',
      },
    },
  },
  user: {
    main: 'user',
    exists: 'user/exists/user',
    credits: 'user/credits',
    performance: {
      preferences: 'user/performance/preferences',
    },
    preferences: 'user/preferences',
    onboarding: {
      integrations: 'user/onboarding/integrations',
      features: 'user/onboarding/features',
    },
    manager: 'user/manager',
    guidedTours: 'user/guidedTours',
    me: 'user/me',
    callIntegrationType: 'user/callIntegrationType',
    callIntegration: 'user/callIntegration',
    search: 'user/search',
  },
  list: {
    main: 'list',
    search: 'list/search',
    prospect: {
      main: 'list/prospect',
      all: 'list/prospect/all',
      set: 'list/prospect/set',
    },
    setTeamMembers: 'list/setTeamMembers',
    setUserTeams: 'list/user/setTeams',
    template: {
      main: 'list/template',
      all: 'list/template/all',
      set: 'list/template/set',
    },
    strategy: {
      main: 'list/strategy',
      all: 'list/strategy/all',
      set: 'list/strategy/set',
    },
    account: {
      main: 'list/account',
      all: 'list/account/all',
      set: 'list/account/set',
    },
    multiple: {
      account: 'list/multiple/account',
      prospect: 'list/multiple/prospect',
    },
  },
  promptLibrary: {
    search: 'promptLibrary/search',
  },
  signal: {
    main: 'signal',
    search: 'signal/search',
    preferences: {
      main: 'signal/preferences',
      disabledUsers: 'signal/preferences/disabled-users',
    },
  },
  snitcherRadar: {
    settings: 'snitcherRadar/settings',
  },
  apiKey: {
    main: 'apiKeys',
  },
  webhookSettings: {
    main: 'webhookSettings',
    all: 'webhookSettings/all',
    events: 'webhookSettings/events',
  },
  warmy: {
    availability: 'Warmy/Availability',
    authorizeUrl: 'Warmy/AuthorizeUrl',
    connectionFailed: 'Warmy/ConnectionFailed',
    dashboard: 'Warmy/Dashboard',
    mailbox: {
      main: 'Warmy/Mailbox',
      connect: 'Warmy/Mailbox/Connect',
      connectSmtp: 'Warmy/Mailbox/ConnectSmtp',
      reconnectSmtp: 'Warmy/Mailbox/ReconnectSmtp',
      state: 'Warmy/Mailbox/State',
      details: 'Warmy/Mailbox/Details',
      settings: 'Warmy/Mailbox/Settings',
      language: 'Warmy/Mailbox/Language',
      dnsHealthCheck: 'Warmy/Mailbox/DnsHealthCheck',
      deliverabilityTest: 'Warmy/Mailbox/DeliverabilityTest',
    },
  },
  phoneNumber: {
    main: 'phoneNumber',
    search: 'phoneNumber/search',
    user: 'phoneNumber/user',
    inbound: 'phoneNumber/inbound',
    verify: {
      main: 'phoneNumber/verify',
      check: 'phoneNumber/verify/check',
    },
  },
  findNewSearch: {
    main: 'findNewSearch',
    search: 'findNewSearch/search',
  },
  findNew: {
    contacts: 'findNew/contacts',
    contactsSearch: 'findNew/contacts/search',
    companies: 'findNew/companies',
    companiesSearch: 'findNew/companies/search',
    companiesSearchByName: 'findNew/companies/searchByName',
    companiesByNumericId: 'findNew/companies/byNumericId',
    companiesFetch: 'findNew/companies/fetch',
    companiesFetchByNumericIds: 'findNew/companies/fetchByNumericIds',
    jobTitlesSearch: 'findNew/jobTitles/search',
    jobTitlesFetch: 'findNew/jobTitles/fetch',
    citiesSearch: 'findNew/cities/search',
    companyCitiesSearch: 'findNew/companyCities/search',
    // One fetch serves both pickers — the id space is the same either way.
    citiesFetch: 'findNew/cities/fetch',
  },
  integration: {
    settings: 'integration/settings',
    crmLists: 'integration/crmLists',
  },
  reditus: {
    token: 'reditus/token',
  },
  ringover: {
    verify: 'ringover/verify',
    apiKeys: 'ringover/apiKeys',
    connect: {
      manager: 'ringover/connect/manager',
      user: 'ringover/connect/user',
    },
  },
  enrichmentProvider: {
    main: 'enrichmentProvider',
    order: 'enrichmentProvider/order',
  },
  oauth: {
    createOAuthAuthorizationCode: 'oauth/createOAuthAuthorizationCode',
    register: 'oauth/register',
  },
  zoomInfo: {
    oauth: 'zoomInfo/callback_oauth',
    oauthStart: 'zoominfo/oauth/start',
  },
  timeline: {
    search: 'timeline/search',
  },
};
